<!-- @format -->

<homefield-icon
	height="14px"
	[class]="icon"
	[name]="icon"
	*ngIf="icon ? true : false"></homefield-icon>
<span
	class="link"
	[ngClass]="{ styled: styled }">
	<ng-content></ng-content>
</span>
